import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';

export const useUpdateSetInspection = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (...args: Parameters<typeof API.deliveries.updateSetInspection>) =>
      API.deliveries.updateSetInspection(...args),
    // refresh the affected caches in the background - the mutation has already succeeded, so
    // don't make the caller wait on these refetches; just let them run concurrently and ignore
    // failures here, the queries will simply refresh again next time they're used
    onSuccess: (_, { deliveryId }) => {
      Promise.all([
        queryClient.invalidateQueries([QueryKeys.Delivery]),
        queryClient.invalidateQueries([QueryKeys.Deliveries]),
        queryClient.invalidateQueries([QueryKeys.TimeStamps, deliveryId]),
        queryClient.invalidateQueries([QueryKeys.TrayCapturePrintOut]),
      ]).catch(() => {});
    },
  });
};
